import { Component, OnInit, OnDestroy, inject } from '@angular/core';
import {
  TransactionSuccessQuery,
  TransactionSuccessService,
  LottoItem,
  DATE_OPTIONS,
  CustomFieldValidationType,
  MarketplaceBasketCustomFieldModel,
} from '@fgb/core';

@Component({
  selector: 'fgb-lottos-success-page',
  templateUrl: './lottos-success-page.component.html',
  styleUrls: ['./lottos-success-page.component.scss'],
})
export class LottosSuccessPageComponent implements OnInit, OnDestroy {
  public lottoItem: LottoItem;
  public totalPrice: number;
  public quantity: number;
  public customFields: MarketplaceBasketCustomFieldModel[] = [];
  readonly dateOptions = inject(DATE_OPTIONS);
  readonly customValidationType = CustomFieldValidationType;
  private readonly transactionSuccessQuery = inject(TransactionSuccessQuery);
  private readonly transactionSuccessService = inject(TransactionSuccessService);

  ngOnInit() {
    const transaction = this.transactionSuccessQuery.getValue();
    this.lottoItem = transaction.item as LottoItem;
    this.totalPrice = transaction.totalPrice;
    this.quantity = transaction.quantity;
    this.customFields = transaction.customFields || [];
  }

  ngOnDestroy(): void {
    this.transactionSuccessService.clear();
  }
}
